<app-pagetitle title="{{nameApp}}" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>
<div class="row">
    <div class="col-sm-12">
        <div class="card card-border">
            <div class="card-header">
                <div class="row">
                    <div class="col-sm-6 text-sm-right">
                        <button type="button" class="btn btn-sm btn-success waves-effect" (click)="openModal()"><i
                                class="fas fa-plus fa-lg mr-1"></i> Nuevo</button>
                    </div>
                </div>
            </div>

            <div class="container card-body table-responsive">
                <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped table-bordered row-border hover">
                    <thead>
                        <tr>
                            <th>Nro.</th>
                            <td>Estratégias</td>
                            <td>Objetivos</td>
                            <th>Estado</th>
                            <th>Detalle</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of dataEstrategiasMain; let indice=index">
                            <td>{{indice+1}}</td>
                            <td>{{row.nombre}} </td>
                            <td>{{row.objetivo}}</td>
                            <td>{{((row.estado == '1')? 'Activo': 'Inactivo')}}</td>
                            <td><button type="button" tooltip="Editar"

                              class="btn btn-sm btn-link waves-effect rounded-pill"
                              title="Editar este registro"
                              (click)="mostrarDetalle(row)">
                              <i class="fas fa-file-alt fa-lg"></i>
                          </button></td>

                            <td class="text-center col-sm-auto">
                                <button type="button" tooltip="Editar"

                                    class="btn btn-sm btn-link waves-effect rounded-pill"
                                    title="Editar este registro"
                                    (click)="edit(row)">
                                    <i class="fas fa-pencil-alt fa-lg"></i>
                                </button>
                                <button type="button" class="btn btn-sm btn-link waves-effect"
                                title="Eliminar este registro"
                                (click)="delete(row)">
                                    <i class="fas fa-trash-alt fa-lg"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
  </div>


<jw-modal id="delete">
      <div class="modal-dialog" style="padding-top:15%">
          <div class="modal-content" >
              <div class="modal-header">
                  <h4 class="modal-title" id="myCenterModalLabel">Advertencia!</h4>
                  <button type="button" class="btn-close"  (click)="modal.close()"></button>
              </div>
              <div class="modal-body">
                  <p class="pl-4"><i class="pl-2 fas fa-exclamation-circle text-warning  fa-lg fa-2x"></i>&nbsp; &nbsp;  Esta seguro que desea eliminar este registro? </p>
              </div>


              <div class="modal-footer">
                  <button type="button" class="btn btn-secondary waves-effect"
                      (click)="modal.close();">Cerrar</button>
                  <button type="button" class="btn btn-primary" (click)="confirmDelete()"
                      >Si, borrar!</button>
              </div>


          </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
</jw-modal>


<jw-modal id="{{nameModal}}">
  <!-- MODAL PARA CREAR Y EDITAR -->
      <div class="modal-dialog" style="padding-top:6%">
          <div class="modal-content">
              <div class="modal-header pb-3">
                  <h3 class="modal-title">{{nameApp}}</h3>
                  <button type="button" class="btn-close" (click)="modal.close();"
                      aria-label="Close"></button>
              </div>
              <div class="modal-body pT-4">
                  <form action="#" [formGroup]="formEstrategias" class="needs-validation was-validated">
                      <div class="row">
                          <input type="hidden" id="idSprEstrategia" formControlName="idSprEstrategia">
                          <div class="form-floating mb-3">
                            <select class="form-select" formControlName="idSprObjetivo" required="true"
                            [ngClass]="{'is-invalid': this.formEstrategias.get('idSprObjetivo')?.errors  && this.formSubmitted  }">
                            <option value="" selected="selected">Seleccionar objetivo..</option>
                            <option *ngFor="let row of dataObjetivo" value={{row.idSprObjetivo}}>
                              {{row.nombre}}
                            </option>
                          </select>
                            <label for="nombre">Alineación objetivo</label>
                      </div>


                          <div class="form-floating mb-3">
                                <input type="text" id="nombre" class="form-control" formControlName="nombre" required
                                    autofocus placeholder="Nombre"
                                    [ngClass]="{'ng-invalid ng-dirty' : submitted && EstrategiasForm['nombre'].errors}">
                                <small class="invalid-feedback" *ngIf="submitted && EstrategiasForm['nombre'].errors">Campo
                                    requerido</small>
                                <label for="nombre">Nombre</label>
                          </div>
                            <div class="form-floating mb-3">
                                <select id="estado" class="form-select" formControlName="estado" required>
                                    <option [value]="item.value" *ngFor="let item of selectItems">{{item.label}}
                                    </option>
                                </select>
                                <label for="estado">Estado</label>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary waves-effect"
                        (click)="modal.close();">Cerrar</button>
                    <button type="button" class="btn btn-info" (click)="onSubmit()"
                        >Guardar</button>
                </div>
            </div>
        </div>
  </jw-modal>
